module.exports = __webpack_public_path__ + "img/foodpanda-logo.fd5f9239.png";